// utils/config.js
const apiBaseUrl = window.location.hostname === 'localhost'
  ? 'http://localhost:8080/api'
  : '/api';

export default apiBaseUrl;